import { render, staticRenderFns } from "./AnalyticsDeleteSavedQueryModal.vue?vue&type=template&id=47f1c6c4"
import script from "./AnalyticsDeleteSavedQueryModal.vue?vue&type=script&lang=js"
export * from "./AnalyticsDeleteSavedQueryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports